import React from "react";
import PropTypes from "prop-types";
import { Tag } from "antd";

import "styles/kan-ban-card-item.css";

class KanBanCardItem extends React.Component {
    onCardClick = () => {
        const { onClick, id, companyId, title } = this.props;
        onClick(id, title, companyId);
    };
    render() {
        const { title, aging, list, tags } = this.props;
        return (
            <div className={"kan-ban-card-item"} onClick={this.onCardClick}>
                <div className={"kan-ban-card-header"}>
                    <div className={"kan-ban-card-header-title"}>{title}</div>
                    <div className={"kan-ban-card-header-extra"}>{aging}</div>
                </div>
                <div className={"kan-ban-card-body"}>
                    {list.map(_ => (
                        <div key={_[0]} className={"kan-ban-card-list-item"}>
                            <div className={"kan-ban-card-item-key"}>
                                {_[0]}
                            </div>
                            <div className={"kan-ban-card-item-value"}>
                                {_[1]}
                            </div>
                        </div>
                    ))}
                    {tags.map(_ => (
                        <Tag key={_} color={_.color}>
                            {_.value}
                        </Tag>
                    ))}
                </div>
            </div>
        );
    }
}

KanBanCardItem.propTypes = {
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
    aging: PropTypes.string,
    list: PropTypes.object,
    tags: PropTypes.object,
    id: PropTypes.number,
    companyId: PropTypes.number,
    onClick: PropTypes.func
    // checked: PropTypes.bool,
    // toggleCheck: PropTypes.func
};

export default KanBanCardItem;
